import React from 'react';
import { motion } from 'framer-motion';
export function DiagnosticExpertise() {
  return <section className="py-24 px-4 bg-brand-dark text-white relative overflow-hidden" data-id="element-55">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-56">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-brand-accent blur-3xl" data-id="element-57"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 rounded-full bg-brand-accent blur-3xl" data-id="element-58"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-60">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-61">
            Experience matters
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold mb-10 pl-[150px] pr-[150px]" data-id="element-62">
            Modern vehicles require real diagnostic expertise
          </h2>
        </motion.div>

        {/* Diagnostic technician image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="mb-12 rounded-xl overflow-hidden shadow-2xl shadow-black/30 border border-white/10" data-id="element-63">
          <img src="https://cdn.magicpatterns.com/uploads/vApaAnuQ7KNKT2i4jNxPw2/7.5.24Used-0316_Profile_RW_003.jpg" alt="ASE-certified master technicians using advanced diagnostic equipment to inspect a vehicle" className="w-full h-auto object-cover max-h-[480px]" data-id="element-64" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-8 text-xl md:text-2xl text-gray-300 leading-relaxed font-medium text-center" data-id="element-65">
          <p data-id="element-66">
            Today's vehicles contain dozens of computers, sensors, and
            interconnected systems. Identifying the real cause requires more
            than reading a fault code.
          </p>
          <p data-id="element-67">
            Our auto repair technicians diagnose hundreds of complex issues
            every year across many makes and models. By inspecting the full
            system before recommending repairs, we ensure expensive components
            are only replaced when they are truly necessary.
          </p>
          <p className="font-heading text-white font-bold text-2xl md:text-3xl py-4" data-id="element-68">
            When the diagnosis is correct, the repair is usually much simpler.
          </p>
        </motion.div>
      </div>
    </section>;
}